export default __webpack_public_path__ + "static/media/modal-close-button-grey.f5eca29b.svg";